import React from "react";
import { generateDeviceId, logoutSession, logoutSessionnew, saveDeviceToken } from "./CheckMultiLogin";
import { Auth } from "aws-amplify";
import usersService from "../../components/main/body/screens/IAM/Users/users.service";
import { useContext,createContext } from "react";
import { rootStoreContext } from "../../store";

export const CheckMultiLoginFun = async () => {
    let username;
   // const { rootStore } = useContext(rootStoreContext);
    // get user info
    let userInfo = localStorage.getItem("userinfo");
    console.log("userInfo in checkMultiLoginFun", userInfo);
    if(userInfo) {
        username = JSON.parse(userInfo)?.username;
    }
    // device id
    if (username != undefined || username != null) {
        let deviceId = await generateDeviceId();
        console.log("deviceId", deviceId);

        // get store device token
        let res = await usersService.getDeviceToken(username);
        console.log("store device token",res);

        if (res.deviceToken == null) {
            await saveDeviceToken();
        } else if (res.deviceToken !== deviceId) {
            // await logoutSession(rootStore);
            await logoutSessionnew()
        }
    }
}